<hw-page-header
  header="{{ editView ? 'term.di-02.header-edit' : 'term.di-02.header-add' }}"
  class="page-header"
  (onBack)="goBack()">
  <div class="content float-right">
    <button (click)="form.valid && save()" class="float-right" nz-button nzType="primary">
      {{ 'core.btn.save' | translate }}
    </button>
  </div>
</hw-page-header>

<nz-content class="main" *ngIf="dictionary">
  <form nz-form #form="ngForm">
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="id" [required]="true" label="term.di-02.id">
          <input nz-input name="id" [(ngModel)]="dictionary.id" [disabled]="!isNew" required />
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="title" label="term.di-02.title">
          <hw-multilang-input name="title" [(ngModel)]="dictionary.title"></hw-multilang-input>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="names" label="term.di-02.names">
          <hw-multilang-input name="names" [(ngModel)]="dictionary.names"></hw-multilang-input>
        </hw-form-item>
      </div>
    </hw-form-row>
    <hw-form-row>
      <div *hw-form-col>
        <hw-form-item name="publisher" label="term.di-02.publisher">
          <input nz-input name="publisher" [(ngModel)]="dictionary.publisher" />
        </hw-form-item>
      </div>
    </hw-form-row>
  </form>

  <hw-table header="term.di-02.attributes">
    <div headerContent>
      <button (click)="newAttribute()" class="button" nz-button nzType="secondary">
        {{ 'core.btn.add' | translate }}
      </button>
    </div>
    <nz-table
      #editRowTable
      [nzData]="dictionary.attributes"
      nzSize="small"
      nzHideOnSinglePage="true"
      nzShowSizeChanger="false"
      nzFrontPagination="false">
      <thead>
        <tr>
          <th>{{ 'term.di-02.attrs.id' | translate }}</th>
          <th>{{ 'term.di-02.attrs.name' | translate }}</th>
          <th>{{ 'term.di-02.attrs.type' | translate }}</th>
          <th>{{ 'term.di-02.attrs.required' | translate }}</th>
          <th>{{ 'term.di-02.attrs.default' | translate }}</th>
          <th nzShowExpand></th>
        </tr>
      </thead>
      <tbody>
        <ng-template ngFor let-row [ngForOf]="editRowTable.data">
          <tr>
            <td>{{ row.id }}</td>
            <td>{{ row.names | localName }}</td>
            <td>{{ row.datatype }}</td>
            <td><i class="fa fa-check" *ngIf="row.required"></i></td>
            <td>
              <span *ngIf="row.datatype === 'translations'"> {{ row.defaultValue | localName }} </span>
              <span *ngIf="row.datatype !== 'translations'"> {{ row.defaultValue }} </span>
            </td>
            <td nzShowExpand [(nzExpand)]="row.expand"></td>
          </tr>
          <tr [nzExpand]="row.expand">
            <td></td>
            <td colspan="5">
              <form nz-form>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="id" [required]="true" label="term.di-02.attrs.id">
                      <input nz-input name="id" [(ngModel)]="row.id" required />
                    </hw-form-item>
                  </div>
                </hw-form-row>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="names" label="term.di-02.attrs.name">
                      <hw-multilang-input name="names" [(ngModel)]="row.names"></hw-multilang-input>
                    </hw-form-item>
                  </div>
                </hw-form-row>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="required" label="term.di-02.attrs.required">
                      <input nz-input type="checkbox" name="required" [(ngModel)]="row.required" />
                    </hw-form-item>
                  </div>
                </hw-form-row>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="type" label="term.di-02.attrs.type">
                      <nz-select name="type" [(ngModel)]="row.datatype" (ngModelChange)="onAttrTypeChange(row)">
                        <nz-option *ngFor="let o of attrTypes" [nzLabel]="o" [nzValue]="o"></nz-option>
                      </nz-select>
                    </hw-form-item>
                  </div>
                </hw-form-row>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="length" label="term.di-02.attrs.length" *ngIf="row.datatype === 'text'">
                      <input nz-input name="length" [(ngModel)]="row.parameters['length']" />
                    </hw-form-item>
                    <hw-form-item name="range" label="term.di-02.attrs.range" *ngIf="row.datatype === 'number'">
                      <input nz-input name="range" [(ngModel)]="row.parameters['range']" />
                    </hw-form-item>
                    <hw-form-item
                      name="codesystem"
                      label="term.di-02.attrs.codesystem"
                      *ngIf="row.datatype === 'codesystem'">
                      <hw-term-codesystem-select
                        name="codesystem"
                        [(ngModel)]="row.parameters['codesystem']"></hw-term-codesystem-select>
                    </hw-form-item>
                    <hw-form-item
                      name="dictionary"
                      label="term.di-02.attrs.dictionary"
                      *ngIf="row.datatype === 'dictionary'">
                      <hw-term-dictionary-select
                        name="dictionary"
                        [(ngModel)]="row.parameters['dictionary']"></hw-term-dictionary-select>
                    </hw-form-item>
                  </div>
                </hw-form-row>
                <hw-form-row>
                  <div *hw-form-col>
                    <hw-form-item name="default" label="term.di-02.attrs.default">
                      <hw-term-attribute-input
                        [(ngModel)]="row.defaultValue"
                        [attribute]="row"
                        name="default"></hw-term-attribute-input>
                    </hw-form-item>
                  </div>
                </hw-form-row>
              </form>
            </td>
          </tr>
        </ng-template>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
